module.exports = __webpack_public_path__ + "static/media/gallery06.5de142a2.png";